import React from "react";
export const LanguageContext = React.createContext();
export const LanguageConsumer = LanguageContext.Consumer;
